// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ressigniflix.firebaseapp.com",
  "projectId": "ressigniflix",
  "storageBucket": "ressigniflix.appspot.com",
  "messagingSenderId": "38420439535",
  "appId": "1:38420439535:web:f69d4932916d797067961a",
  "measurementId": "G-08JNY7WK4Y",
  "apiKey": "AIzaSyAbV8jViIIT-H-5ZIlh42vledsbnopvOCM"
};
